export default __webpack_public_path__ + "static/media/newLogo2.ccc52df6.png";